// Port of api/fuel/app/classes/insights/ratings/type.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Category from 'offline/model/category'
import Mechanic from 'offline/model/mechanic'

export default Segment.extend({
	name: 'type',
	default_: false,
	insight: false,
	run: function(type, owner, userIndex, detail, filter, vars) {

		if (!owner.get_count_ratings()) return {}

		var typeFilter = (filter.type !== undefined) ? filter.type : 'category'
		var typeName = ''

		if (typeFilter === 'category') {
			var category = Category.with_id(vars.id)
			typeName = category ? category.get_name() : ''
		} else {
			var mechanic = Mechanic.with_id(vars.id)
			typeName = mechanic ? mechanic.get_name() : ''
		}

		var table = (typeFilter === 'category') ? 'category' : 'mechanic'
		var games = []

		var ratings = Util.query(
			'SELECT l.game_id AS g, AVG(r.rating_value) AS r, COUNT(DISTINCT r.rating_id) AS c' +
			' FROM game_' + table + ' l, game g, rating r' +
			' WHERE l.' + table + '_id = ' + vars.id +
			' AND g.game_id = l.game_id' +
			' AND g.game_type = 1' +
			' AND r.game_id = g.game_id' +
			' AND r.user_id IN (' + Util.in(userIndex) + ')' +
			' GROUP BY l.' + table + '_id, l.game_id' +
			' ORDER BY AVG(r.rating_value) DESC, g.game_name ASC' +
			' LIMIT 0, 250'
		)

		for (var i = 0; i < ratings.length; i++) {
			var game = ratings[i]
			var gameId = parseInt(game.g, 10)
			this._references.games.push(gameId)
			games.push({
				id: gameId,
				count: parseInt(game.c, 10),
				rating: game.r ? parseFloat(game.r) : '-'
			})
		}

		return {
			type: typeName,
			games: games
		}

	}
})
